__turbopack_context__.v({
  "map": "style-module-scss-module__8y9sGq__map",
  "map-loading": "style-module-scss-module__8y9sGq__map-loading",
  "map-spinner": "style-module-scss-module__8y9sGq__map-spinner",
  "remove-boundary": "style-module-scss-module__8y9sGq__remove-boundary",
  "slide-up": "style-module-scss-module__8y9sGq__slide-up",
});
